import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useTenantlessRoute = () => {
  const location = useLocation();
  const [route, setRoute] = useState(location.pathname);

  // When location changes, update the path
  useEffect(() => {
    // Strip off the tenant code
    const pathLessTenant = location.pathname.split('/').slice(2).join('/');
    setRoute(pathLessTenant);
  }, [location.pathname]);

  return { route };
};
